import { Stack, Text } from '@chakra-ui/react'
import { isBefore, parseISO, isAfter, isEqual } from 'date-fns/esm'
import React, { FC } from 'react'
import { useLang } from '../../common/i18n/useLang'
import { Announce } from './Announce'

const START_PSD_APPLICATION_CLOSED = parseISO('2025-05-31T00:00:00+09:00')
const END_PSD_APPLICATION_CLOSED = parseISO('2025-08-31T23:59:00+09:00')

export function showPsdApplicationClosed() {
  const now = new Date()
  // Show if current time is on or after start and before or equal to end
  const isAfterStart = isAfter(now, START_PSD_APPLICATION_CLOSED) || isEqual(now, START_PSD_APPLICATION_CLOSED)
  const isBeforeEnd = isBefore(now, END_PSD_APPLICATION_CLOSED) || isEqual(now, END_PSD_APPLICATION_CLOSED)
  return isAfterStart && isBeforeEnd
}

export const Maintenance: FC<{ radius?: number; className?: string }> = ({ radius, className }) => {
  const { language } = useLang()
  const shouldShowPsdClosed = showPsdApplicationClosed()

  if (!shouldShowPsdClosed) {
    return null
  }

  return (
    <Stack spacing={4} className={className}>
      {shouldShowPsdClosed && (
        <Announce
          type={'warning'}
          title={language === 'ja' ? '大切なお知らせ' : 'Important Notice'}
          date={'2025/05/31'}
          body={
            language === 'ja' ? (
              <div>
                2026年度システム情報科学府入学試験のためのPSD申請は2025年5月30日をもって終了しました。
              </div>
            ) : (
              <div>
                Calls for the pre-admission request for the 2026 ISEE entrance exams were closed on May 30, 2025.
              </div>
            )
          }
        />
      )}
    </Stack>
  )
}
